import { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import HomePage from "@/pages/HomePage";
import SectorDetailPage from "@/pages/SectorDetailPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.history.state?.usr?.scrollTo) {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/sectors/:slug" element={<SectorDetailPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0A1128",
              color: "#F4F4F0",
              border: "1px solid rgba(197,168,128,0.3)",
              borderRadius: "2px",
              fontFamily: "'Outfit', sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
